import { CodigoEquipoModel } from '@/store/catalogos/codigoEquipo';
import { properties } from '@/utils/properties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class CatalogoCodigoEquipoService {
  private readonly baseUrl = properties.URL_CATALOGOS + 'codigoEquipos';

  constructor(private http: HttpClient) { }

  getAll(): Observable<CodigoEquipoModel[]> {
    return this.http.get<CodigoEquipoModel[]>(this.baseUrl, httpOptions);
  }

  create(codigoEquipo: CodigoEquipoModel): Observable<CodigoEquipoModel> {
    return this.http.post<CodigoEquipoModel>(this.baseUrl, codigoEquipo, httpOptions);
  }

  update(codigoEquipo: CodigoEquipoModel): Observable<CodigoEquipoModel> {
    return this.http.put<CodigoEquipoModel>(`${this.baseUrl}/${codigoEquipo.idCodigoEquipo}`, codigoEquipo, httpOptions);
  }


}
